import React, { useState } from 'react';
import './CardSlider.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { Link as RouterLink } from 'react-router-dom';

const Link = ({ to, children, ...rest }) => {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <RouterLink to={to} onClick={handleClick} {...rest}>
      {children}
    </RouterLink>
  );
};

const CardSlider = ({ data, CurrentPage }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const cardsPerSlide = 4;

  const cards = data;
  const totalSlides = Math.ceil(cards.length / cardsPerSlide);

  const handleNextClick = () => {
    setCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
  };

  const handlePrevClick = () => {
    setCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
  };

  return (
    <div className="CardSlider-Main">
      <div className="CardSlider-container">
        <div
          className="CardSlider-wrapper"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {cards.map((card, index) => {
            const cardId = card._id?.$oid || card._id; // Extract ID for the URL
            return (
              <Link to={`${CurrentPage}/${cardId}`} className="CardSlider-section" key={index}>
                <img src={card.icon} alt={`icon-${index}`} className="CardSlider-icon" />
                <h1 className="CardSlider-title">{card.title}</h1>
              </Link>
            );
          })}
        </div>
      </div>
      <div className="CardSlider-buttoncontain">
        <FontAwesomeIcon icon={faAngleLeft} className="CardSlider-directionicon" onClick={handlePrevClick} />
        <div className="CardSlider-dots">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <span
              key={index}
              className={`CardSlider-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            ></span>
          ))}
        </div>
        <FontAwesomeIcon icon={faAngleRight} className="CardSlider-directionicon" onClick={handleNextClick} />
      </div>
    </div>
  );
};

export default CardSlider;
